module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p9"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "flourish",
      "src": "images/flourish.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "sz"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie packed the last of Charlotte's old clothes into the trunk and closed the lid. On hands and knees, she pushed it across the wide pine floor, arranging it in an orderly fashion next to the other two trunks. Soon, they would hold the rest of the items that Charlotte had asked her to send.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Her sister-in-law wanted nothing in the way of furniture from the house; Charlotte had already retrieved her father's desk and books, as well as her grandmother's oval mirror, before the wedding. Sophie could see why Charlotte didn't want the rest. The furnishings were shabby at best or simply functional with nothing of beauty to recommend them.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Even the ancient upright—though Sophie had been happy to see it in the sitting room—was one of the most pathetic excuses for a piano she'd ever had the misfortune to play. But play it she did, on the very first day, as soon as Doc had dragged in her trunk and Sarah had given her a basket of food, and they'd left. Sophie whipped off the sheet covering the old instrument and settled down to play.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Terribly out of tune, the piano still bent to Sophie's artistry and the music that resulted made her mind calm and her heart peaceful. Ten minutes passed, half an hour, an hour. She was starting a new life, she reminded herself; she just wasn't sure what that new life entailed yet, whether heading back to Boston or to Europe, or where.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("However, for the time being, she was satisfied with having put even more distance between herself and Philip's familiar, beloved face—and Philip's treacherously fickle heart and Philip's warm smile and his even warmer hands—and his unthinkingly cruel words. She pounded the keys, dissonant bass chords, until the sounds drowned out the thoughts in her head. So much for a peaceful heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("At least, she'd stopped crying.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("When the sun was midway across the clear blue sky on her third day in Spring City, Sophie left the Sanborn homestead and walked to town. Not far, especially on a beautiful, late summer day. She felt as if she knew at least some of the people from Charlotte's animated stories of the town.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She went to Webster's store and met Jeremiah and his granddaughter, Anna, who talked a mile a minute when she found out who Sophie was; naturally, she was full of questions about Charlotte, the town's renowned literary daughter. Sophie smiled. Only her brother Reed could go halfway across the continent to a dried up little town on the most solemn of legal tasks and find the brightest gem of a woman to take for his wife.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie bought new gloves and headed for Fuller's, which Charlotte swore served the best turkey pie. Sophie sat in the window and ate, not concerned by the curious stares of the townsfolk. Some had greeted her, already knowing she was Charlotte Sanborn Malloy's sister-in-law, thanks to Sarah Cuthins.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Thank you,\" Sophie said as the waitress came back with more coffee. \"Charlotte was right about the pie.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Jessie Hollander smiled broadly. \"Shoot. That ain't nothin'. Wait till you try my lemon cake.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"That's what I'm here for, too,\" said a voice behind her, and Sophie turned to see Riley, not any cleaner than the last time she'd seen him. But she was damned if, even dirty, he wasn't the most attractive man she'd ever laid eyes on. "), _c('i', [_vm._v("Why hadn't Charlotte mentioned him?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Sophie,\" he said, tipping his black hat. His eyes were fixed on hers, with a small frown between his eyebrows. He looked like a man bothered.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Riley,\" Sophie returned, by way of greeting.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Jessie stood, hands on hips. \"Riley, what do you think you're doing, coming in here covered in trail dust, unsettlin' my customers?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie watched him shrug. \"You know what "), _c('i', [_vm._v("she's")]), _vm._v(" like when she wants something,\" he said by way of explanation. Sophie's ears perked up. Another reference to the mysterious woman who might be \"hopping mad\" perhaps?")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Jessie nodded. \"Oh, I know, all right. I'll be back in a jiffy. Two pieces?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Riley raised his eyebrows. \"Might as well. I would've eaten hers before I got back, I suppose.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Jessie turned back to Sophie.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"And you, miss? A slice?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie shook her head. \"No, thank you. Another time, perhaps.\" She stood up and started to sort through her purse for the right change. She noticed that Riley remained standing, a couple feet away. She could feel his eyes on her, but then, that had been the case with all the townsfolk all day.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You're missing out,\" he said, making her jump. \"The lemon cake is just the right blend of tart and sweet.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Philip would have philosophized about how the cake held all the elements of life if it truly blended those two opposing elements so perfectly. She sighed. "), _c('i', [_vm._v("Why did he have to pop into her brain without bidding?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She tried to smile at Riley, but felt the ache in her heart grow again. Was it simply because she was near a man? Or was it being near a man who had absolutely no feeling for her? She belonged to no one now and idly wondered what Riley's woman was like, the one who apparently could be a handful when she wanted something and didn't get it, a little like Sophie's younger sister, she guessed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Good day,\" she said, as she passed him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"G'day, ma'am,\" he called after her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She walked slowly up Main Street, passing the feed store, the general store, Webster's, Ada's Saloon. People were all going about their business. Tomorrow, she would set about working a little more quickly and perhaps finish the packing. The sooner she sent the trunks back to Boston, the sooner she would be free to decide what to do next.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Hey, Sophie.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She slowed her pace as Riley fell into step beside her; she was unsure whether it was allowed for her to walk with this man she barely knew. But things were different in Spring City, Charlotte had assured her, not as rigid as in Boston's society, which was ruled by propriety and a bewildering array of social mores. One false step and you could be ruined there. Here, Sophie supposed she could walk without recrimination along the town's main thoroughfare, next to this tall easygoing man.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Where're you headed?\" Riley asked, swinging a small white cake box by its string with such vigor that it could only mean disaster for its contents.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Home,\" Sophie said, distracted by his motions. \"Um, you might want to be careful with that,\" she indicated the box that was now being twirled nearly upside down, \"if you want to have any semblance of cake left to give to your... wife?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Riley's faced grew serious. \"Fiancée,\" he corrected.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Congratulations,\" Sophie offered, not sure what else to say despite the lack of joy in his expression.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("After the briefest of pauses, Riley laughed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"What is it?\" Sophie couldn't help asking.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"No one else in this town has congratulated me on my engagement. Rather the opposite.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Sophie was intrigued, and despite her better manners, was going to ask about the situation when Riley stopped.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As she had done earlier in the week, she asked, \"Why have we stopped?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He gestured to a two-story, yellow house behind him with painted shutters, a carefully tended yard, and a wraparound porch that begged to be sat on.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yours?\" Sophie guessed.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"My fiancée's family home.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Then you'd best be taking her the cake, post haste,\" Sophie advised, tilting her head to the side and finding herself more than a little curious as to this man's story and his fiancée's, for that matter.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I hope I'll see you again,\" he said to her, touching the brim of his hat.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She smiled at him and took a step back. Riley took a step toward the porch.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"It was a pleasure,\" he added, seeming to mean it, with a half-smile on his face and small crinkles at the corners of his eyes. She had to own up to feeling a frisson of pleasure herself, just looking at the man.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Thank you,\" she told him and took another step, still facing Riley who was framed from behind by the pretty house. But she had to ask him.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Riley, what do you do to get so dirty each day?\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("As soon as the words were out, she clapped a hand to her mouth. "), _c('i', [_vm._v("Oh my God, what had possessed her?")])])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("But he didn't take offense. Instead, his smile turned into a genuine grin that made Sophie's insides do a little dance.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I ride,\" he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Ride?\" she repeated.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("He nodded and looked past her toward the open landscape beyond the town.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I ride, just for the hell of it. Pardon my language. I've got a great mount right now, and he loves to run, and so do I.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She must have frowned because he laughed. \"You look puzzled.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I... I guess I thought.\" She closed her mouth. "), _c('i', [_vm._v("What had she thought?")]), _vm._v(" That he would tell her he was a stable hand or a horse trader or even a rancher. How odd. Clearly, he wasn't a farmer. Hm, he had time to gallop on his horse for sheer pleasure. Perhaps no gainful employment, yet how did he keep a fiancée? Whom no one congratulated him on getting?")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Never mind,\" she said, giving a little shrug and taking another step away from him. She wanted to ask him a whole host more questions, but he wasn't her business.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"You should deliver that cake.\"")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"I should,\" he agreed, but his eyes were locked on hers and he wasn't moving.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("\"Yes,\" she heard herself say and then, finally, she turned toward Charlotte's house. After a few steps, she felt the urge to look back, certain for some reason that Riley was standing still, watching her walk away.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("She didn't turn, but as she passed Drake's barn, she considered how quickly Charlotte and Reed's romance had heated up in there, according to Charlotte's telling, and she hummed to herself.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("If Riley were looking at her, she would think it a small binding on the tatters of her heart that such a devilishly handsome man might have some small interest in her. She decided to hold on to that thought rather than turn her head and look.")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("* * *")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("Riley watched her until she was out of his sight. He had been unable to resist going into Fuller's after he saw her through the window. Shit! Why had he wasted his time talking about lemon cake that he would end up eating himself, since Eliza hated citrus? He should have asked Sophie the million questions going through his mind, like what hocus-pocus she was using that made his mouth go dry each time he saw her.")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("And how in the heck was he going to stay away from her when all he wanted was to get closer?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d5a9e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section7.vue
// module id = 75
// module chunks = 0